import { createContext, useContext, useState } from "react";
import * as Yup from "yup";

const UserManagementContext = createContext();

const userInitialState = {
  username: "",
  email: "",
  mobile: null,
};

export const UserManagementContextProvider = ({ children }) => {
  const [addNewUser, setAddNewUser] = useState(userInitialState);
  const [addUserModal, setAddUserModal] = useState(false);

  const handleAddNewUserChange = (data) => {
    let { name, value } = data.target;
    if (name == "mobile") {
      value = value.replace(/[^0-9]/g, "");
      if (value?.length <= 10) {
        setAddNewUser((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setAddNewUser((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleAddUserModalCancel = () => {
    setAddUserModal(false);
    setAddNewUser(userInitialState);
  };

  const handleAddUserModalOpen = () => {
    setAddUserModal(true);
  };

  const handleAddNewUser = async () => {};
  return (
    <UserManagementContext.Provider
      value={{
        addNewUser,
        handleAddNewUserChange,
        handleAddNewUser,
        addUserModal,
        handleAddUserModalCancel,
        handleAddUserModalOpen,
        setAddUserModal,
        setAddNewUser,
      }}
    >
      {children}
    </UserManagementContext.Provider>
  );
};

export const useUserManagementContext = () => useContext(UserManagementContext);
